import Vue from "vue";
import CKEditor from 'ckeditor4-vue';
import DocumentTemplateService from "@/service/DocumentTemplateService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { DocTemp } from "@/model/DocTemp";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import documentTemplateValidationObj from "./S080700-DocumentTemplateValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var documentTemplateDataValidationObj = new documentTemplateValidationObj();
Vue.use(CKEditor);
export default {
  name: "DocumentTemplate",
  mounted() {
    documentTemplateDataValidationObj.documentTemplateValidation();
    this.assignRights();
    this.getDocTypes();
    this.getAllSysVar();
    this.resetDocTempData();
    this.init();
    this.getAllDocTemps();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_DocumentTemplate,
    Settings: Settings,
    dictEnum: dictEnum,
    docTemp: new DocTemp(),
    isEditMode: false,
    docTempList: [],
    docTypeList: [],
    sysVarList: [],
    selectAllDocTemp: false,
    selectAllSysVar: false,
    tempDocTempModel: new DocTemp(),
    isCkeditor: true,
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
    editorConfig: {
      extraPlugins: 'print,pagebreak',
      toolbar: [
        { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'ExportPdf', 'Preview', 'Print', '-', 'Templates'] },
        { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
        { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
        { name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
        '/',
        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
        { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
        { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
        '/',
        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
        { name: 'colors', items: ['TextColor', 'BGColor'] },
        { name: 'tools', items: ['Maximize', 'ShowBlocks'] }

      ]
    },
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".docTemp-table table thead").height();
      var ckeditorHeaderHeight = $(".ckeditor-header").height();
      var ckeditorTopHeight = $(".cke_top").height();
      var pagginationHeight = $(".paggination-docTemp").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 58;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var ckeditorHeight = ckeditorHeaderHeight != undefined && ckeditorHeaderHeight != 0 ? ckeditorHeaderHeight : 34;
      var ckeditorTop = ckeditorTopHeight != undefined && ckeditorTopHeight != 0 ? ckeditorTopHeight : 99;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
      var editorHeight = docHeight - headHeight - tabHeaderHeight - ckeditorHeight - ckeditorTop - 100;
      $(".cke_contents").height(editorHeight);
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllDocTemps() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await DocumentTemplateService.getAllDocTempList(obj);
      if (response.data.IsSuccess) {
        self.docTempList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changepage(self.currentpage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDocTypes() {
      const obj = {};
      const response = await DocumentTemplateService.getDocTypes(obj);
      if (response.data.IsSuccess) {
        this.docTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllSysVar() {
      const obj = {};
      const response = await DocumentTemplateService.getAllSysVar(obj);
      if (response.data.IsSuccess) {
        this.sysVarList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDocTypeDetail() {
      var self = this;
      const obj = {
        type: self.tempDocTempModel.Type,
        tempCode: self.tempDocTempModel.TempCode,
      };
      const response = await DocumentTemplateService.getDocTempDetailByTypeAndTempCode(obj);
      if (response.data.IsSuccess) {
        this.docTemp = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllDocTempRecord: function () {
      var self = this;
      var IsSelected = self.selectAllDocTemp;
      self.docTempList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleDocTempPopup: function () {
      var arrayList = [];
      var self = this;
      self.docTempList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteDocTempModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleDocTemp() {
      var arrayList = [];
      var self = this;
      $('#deleteDocTempModel').modal('hide');
      self.docTempList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        docTempList: arrayList,
      };
      const response = await DocumentTemplateService.deleteDocTemp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTempData();
        self.init();
        await self.getAllDocTemps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnDocTempSelect: function (model) {
      this.tempDocTempModel = model;
      this.isCkeditor = false;
    },
    addDocTemp: function () {
      var self = this;
      $('#docTempModel').modal('show');
      self.isEditMode = false;
      self.docTemp = new DocTemp();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveDocTempData(obj) {
      var self = this;
      const response = await DocumentTemplateService.addDocTemp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTempData();
        self.init();
        await self.getAllDocTemps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditDocTempData(obj) {
      var self = this;
      const response = await DocumentTemplateService.updateDocTemp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTempData();
        self.init();
        await self.getAllDocTemps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveDocTemp() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#docTempModel').modal('hide');
          const obj = {
            model: {
              Type: self.docTemp.Type,
              TempCode: self.docTemp.TempCode,
              CDesc: self.docTemp.CDesc,
              EDesc: self.docTemp.EDesc,
              DocContent: self.docTemp.DocContent,
              AddBy: self.$store.getters[StoreGetter.user].UserID,
              ModifyBy: self.$store.getters[StoreGetter.user].UserID
            }
          };
          if (self.isEditMode) {
            self.EditDocTempData(obj);
          }
          else {
            self.saveDocTempData(obj);
          }
        }
      });
    },
    async editDocTemp() {
      var self = this;
      self.isEditMode = true;
      if (self.tempDocTempModel.Type != "" && self.tempDocTempModel.TempCode != "") {
        await self.getDocTypeDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#docTempModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    async updateDocContent() {
      var self = this;
      if (self.tempDocTempModel.DocContent != "") {
        const obj = {
          model: {
            Type: self.tempDocTempModel.Type,
            TempCode: self.tempDocTempModel.TempCode,
            CDesc: self.tempDocTempModel.CDesc,
            EDesc: self.tempDocTempModel.EDesc,
            DocContent: self.tempDocTempModel.DocContent,
            AddBy: self.$store.getters[StoreGetter.user].UserID,
            ModifyBy: self.$store.getters[StoreGetter.user].UserID
          }
        };
        self.EditDocTempData(obj);
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.LBL_DocContent) + self.t.t(dictEnum.WARN_IsRequired));
      }
    },
    resetDocTempData: function () {
      var self = this;
      self.isCkeditor = true;
      self.selectAllDocTemp = false;
      self.isEditMode = false;
      self.docTemp = new DocTemp();
      self.tempDocTempModel = new DocTemp();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeDocTempPopup: function () {
      var self = this;
      self.isCkeditor = true;
      self.selectAllDocTemp = false;
      self.isEditMode = false;
      self.docTemp = new DocTemp();
      self.tempDocTempModel = new DocTemp();
      self.$validator.reset();
      self.vErrors.clear();
      $('#docTempModel').modal('hide');
    },
    selectAllSysVarRecord: function () {
      var self = this;
      var IsSelected = self.selectAllSysVar;
      self.sysVarList.forEach(function (val, index) {
        val.IsSelectedSysVar = IsSelected;
      });
    },
    onSysVarSelect: function () {
      var arrayList = [];
      var self = this;
      self.sysVarList.forEach(function (key, value) {
        if (key.IsSelectedSysVar) {
          arrayList.push(key.SysVarCode);
        }
      });
      if (arrayList.length > 0) {
        var docContent = "";
        arrayList.forEach(function (key, value) {
          docContent += '<p>' + key + '</p>';
        });
        self.tempDocTempModel.DocContent += docContent;
        self.closeSysVarPopup();
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.WARN_SelectSysVar));
      }
    },
    openSysVar: function () {
      var self = this;
      $('#sysVarModel').modal('show');
      self.resetSysVarPopup();
    },
    closeSysVarPopup: function () {
      var self = this;
      self.resetSysVarPopup();
      $('#sysVarModel').modal('hide');
    },
    resetSysVarPopup: function () {
      var self = this;
      self.selectAllSysVar = false;
      self.sysVarList.forEach(function (val, index) {
        val.IsSelectedSysVar = self.selectAllSysVar;
      });
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllDocTemps();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080700-DocumentTemplate/S080700-DocumentTemplate.js